/**
 * useHomeData.ts — Derive home screen display data from the selected schedule.
 *
 * M2-UX-P0-001: HomeScreen must show active retreat name and duration before Begin.
 * UI-INV-003: Hooks for derived view data.
 * UI-INV-005: No engine imports — schedule is passed in from RetreatBridge.
 */
import type { EditableRetreatSchedule } from "@retreat/core";
import {
  totalSeconds,
  formatDuration,
  displayScheduleName,
} from "../utils/scheduleUtils";

export type HomeData = {
  retreatName: string;
  tradition: string;
  totalDuration: string;
  todayLabel: string;
};

export function useHomeData(
  selectedSchedule: EditableRetreatSchedule | null,
): HomeData {
  const raw = new Date().toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" });
  const todayLabel = raw.replace(", ", " · ");

  if (!selectedSchedule) {
    return { retreatName: "Choose a retreat", tradition: "", totalDuration: "", todayLabel };
  }

  const duration = totalSeconds(selectedSchedule);
  const tradition = selectedSchedule.metadata?.tradition ?? "Zen";

  return {
    retreatName: displayScheduleName(selectedSchedule),
    tradition,
    totalDuration: formatDuration(duration),
    todayLabel,
  };
}
